const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaUsuario: [],
    listaFinalizado: [{
		id: false,
		valor: 'Não'
	}, {
		id: true,
		valor: 'Sim'
	}],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'AGENDA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'AGENDA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'AGENDA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};
		case 'AGENDA_USUARIO_LISTADO':
            return { ...state,
				listaUsuario: action.payload.data
			};

        default:
            return state;
    }
}
